import { ILanguageItem, languages, useTranslatedLanguage, useTranslation, useUserSettings } from "@next-platform/client-common-core";
import { LanguageCode } from "@next-platform/packages-ts-types";
import { useMemo } from "react";

import { SelectionModal } from "@/components/SelectionModal";

const LanguageSelectionModal = ({ closeModal, dataTestId = "" }: { closeModal: (visible: boolean) => void; dataTestId?: string }) => {
  const { t } = useTranslation();
  const { getTranslatedLanguage } = useTranslatedLanguage();
  const { chatLanguage, onUserSetChatLanguage } = useUserSettings();

  const items = useMemo(
    () =>
      languages.map((language: ILanguageItem) => {
        return {
          value: language.code as LanguageCode,
          label: getTranslatedLanguage(language.name),
          description: language.code.toUpperCase(),
        };
      }),
    [getTranslatedLanguage],
  );

  const handleSelectionChange = async (languageCode: LanguageCode) => {
    closeModal(false);
    await onUserSetChatLanguage(languageCode);
  };

  return (
    <SelectionModal<LanguageCode>
      dataTestId={dataTestId}
      open={true}
      onOpenChange={closeModal}
      modalTitle={t("user:profile.modal.languageSelection.title")}
      selectedValue={chatLanguage as LanguageCode}
      items={items}
      onSelectionChange={handleSelectionChange}
      gridCols={{ mobile: 2, desktop: 3 }}
    />
  );
};

export default LanguageSelectionModal;
